// extracted by mini-css-extract-plugin
export var productImage = "_nj-1";
export var viewLink = "_nj-2";
export var wishlistItem = "_nj-0";